import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import type { RateRatingScale } from '@core/utils-legacy';

/**
 * Optional stream of the org's evaluation rating scale, stamped onto score
 * metrics (see `isScoreMetric`) so their `rate` values can render on the scale
 * (e.g. "3.4/5") instead of the plain percent. Must be provided in the root
 * injector (next to `provideReports`) — the visualization facades are
 * root-provided and cannot see route-level providers. Products that don't
 * provide it keep the plain percent formatting.
 */
export const { inject: injectReportsMetricRatingScale, provide: provideReportsMetricRatingScale } =
  createProviderToken<Observable<RateRatingScale | null>>('REPORTS_METRIC_RATING_SCALE')();
